import { iTerms } from "../types/terms"

const TCsModal:React.FC<iTerms> = ({terms}) => {
  
    return (
           
    <div className="modal fade" id="TCsModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">Terms &amp; Conditions </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        
        <div className="modal-body">
       
            <div className="bg-light p-3">
             
                <ul>
                    { terms?.map((term:string, index:number) => {
                        return (
                            <li key={'term-' + index}>
                                {term}
                            </li>
                        )
                    })}
                </ul>
                 <small>By entering the competition you agree to receive marketing from Trailfinders for the duration of the Promotion Period. After this time, you can opt out from receiving marketing communications.</small>
            </div>
        </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-dark p-3 rounded-3" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
        )
    }
    export default TCsModal